import './winmock9/style';
import FormStructure from './winmock9/form_structure';

export default FormStructure;